<template>    
    <modal name="modal-complaint-created" :width="600">
    <div>
     <header class="modal-header py25 px65 h3 sans-serif weight-800 bg-cl-secondary">
      {{ $t('Complaint created') }}
      <i
        slot="close"
        class="modal-close material-icons cl-bg-tertiary"
        @click="close">
        close
      </i>
      </header>
    <div class="modal-content bg-cl-primary pt20 pb30 px65 cl-dark">
      <div class="row mb15">
        <div class="col-xs-12">
          <cms-block-chunk v-show="getRmaType() === 1" :identifier="`c_COMPLAINT_DOOR_2_DOOR_SENT`" default-value="<p/>"/>
          <cms-block-chunk v-show="getRmaType() === 2" :identifier="`c_COMPLAINT_SENT`" default-value="<p/>"/>
          <cms-block-chunk v-show="getRmaType() === 3" :identifier="`c_COMPLAINT_PRINTE_SENT`" default-value="<p/>"/>
          <cms-block-chunk v-show="getRmaType() === 4" :identifier="`c_COMPLAINT_DOM_i_BIURO_SENT`" default-value="<p/>"/>
        </div>
      </div> 
    </div>
    </div>
  </modal>
</template>
<script>
import i18n from '@vue-storefront/i18n'
import Modal from 'theme/components/core/Modal'
import CmsBlockChunk from 'theme/components/core/blocks/Cms/BlockChunk'
import UserComplaints from '@vue-storefront/core/modules/user/components/UserComplaints'

export default {
  name: 'ComplaintCreated',
  mixins: [UserComplaints],
  components: {
    Modal,
        CmsBlockChunk
  },
  methods: {
    getRmaType() {         
        if (this.complaints && this.complaints.length > 0) {
            // we get always sorted complaints from the newest 
            const rmtype = this.complaints[0].rma_type
            switch (rmtype) {
              case 'Door To Door':
                return 1
              case 'Zwrot':
                return 2
              case 'Klient Trzeci':
                return 3
              case 'service':
                return 4                
            }
        } else {
           return 1
        }
    },
    close () {
       this.$bus.$emit('modal-hide', 'modal-complaint-created')
    }
  }
}
</script>
<style scoped>
  .modal {
    font-size: 14px;
    color: black;
  }
  .modal-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .modal-close{
    cursor: pointer;
  }
  .modal-content {
    @media (max-width: 450px) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  
</style>